// src/components/RegisterModal.js
import React from 'react';
import Modal from 'react-modal';
import Register from './Register';

Modal.setAppElement('#root');

const RegisterModal = ({ isOpen, onRequestClose, onRegisterSuccess }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Register"
      className="register-modal"
      overlayClassName="register-modal-overlay"
    >
      <Register
        onRegisterSuccess={onRegisterSuccess}
        onClose={onRequestClose}
      />
    </Modal>
  );
};

export default RegisterModal;
